import React, { createContext, useContext, useState, useEffect } from 'react'

export const OrderModeContext = createContext()

export const ORDER_MODES = {
  DELIVERY: 'delivery',
  PICKUP: 'pickup'
}

export const OrderModeProvider = ({ children }) => {
  const [orderMode, setOrderMode] = useState(ORDER_MODES.DELIVERY)

  useEffect(() => {
    const savedMode = localStorage.getItem('orderMode')
    if (savedMode && Object.values(ORDER_MODES).includes(savedMode)) {
      setOrderMode(savedMode)
    }
  }, [])

  const updateOrderMode = (mode) => {
    setOrderMode(mode)
    localStorage.setItem('orderMode', mode)
  }

  return (
    <OrderModeContext.Provider value={{ orderMode, setOrderMode: updateOrderMode, ORDER_MODES }}>
      {children}
    </OrderModeContext.Provider>
  )
}

export const useOrderMode = () => useContext(OrderModeContext)
